export default __webpack_public_path__ + "static/media/icon-link-copy-3.015f58bf.svg";